export enum SortDirection {
	Ascending = "ascending",
	Descending = "descending"
}
